export default {
  getAll: {
    url: '/api/outverify/getAll',
    method: 'get'
  },
  create: {
    url: '/api/outverify/create',
    method: 'post'
  },
  update: {
    url: '/api/outverify/update',
    method: 'put'
  },
  delete: {
    url: '/api/outverify/delete',
    method: 'delete'
  }
}



// WEBPACK FOOTER //
// ./src/api/outverify.js